import { Button, Container } from 'components';
import styled from '@emotion/styled';

const StyleBoxButton = styled(Button)(props => ({
  width: '100%',
  minWidth: '0',
  maxWidth: '308px !important',
  margin: '0',
}))

const StyleBoxContainer = styled(Container)(props => ({
  paddingTop: '200px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '100% !important'
}))

export { StyleBoxButton, StyleBoxContainer }
